import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { Provider } from 'react-redux';
import { configurePersistor, configureStore } from "./redux/store/store";
import { PersistGate } from "redux-persist/lib/integration/react";
import {ToastContainer} from 'react-toastify'
import { TeamProvider } from './contexts/TeamContext'

import 'react-toastify/dist/ReactToastify.css'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configureStore();
const persistor = configurePersistor(store);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <TeamProvider>
        <PersistGate loading={<div />} persistor={persistor}>
          <App />
          <ToastContainer />
        </PersistGate>
      </TeamProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
